import Cookies from 'js-cookie';
import { COOKIE_NAMES, tenantSpecificConfig } from '../constants';
import { getSiteTenant } from '../tenant';

export const getCheckoutHeaders = (
  currentTenant: string
): Record<string, string> => {
  const { REACT_APP_ENVIRONMENT = 'production' } = process.env;
  const { businessUnit, tenant } = getSiteTenant(currentTenant);
  const tenantConfig =
    tenantSpecificConfig[REACT_APP_ENVIRONMENT][businessUnit][tenant];
  const authSid = Cookies.get(COOKIE_NAMES.AUTH_SID) || '';
  const { ecommName, siteName } = tenantConfig;
  const headers: Record<string, string> = {
    'content-type': 'application/json',
    'X-Channel-Id': 'WEB',
    'X-Commerce': 'FCM',
    'X-Ecomm-Name': ecommName,
    'X-Origin-Name': 'PDP',
    'X-Origin-View': 'Product',
    'X-Site-Name': siteName,
  };
  if (authSid) {
    headers.sid = authSid;
  }
  return headers;
};
